import React, { useContext, useRef, useState, useEffect } from 'react';
import { SettingsBannerContext } from '../../contexts/SettingsBannerContext';
import { BuildAnimationPreview, Keyframe} from '../../helpers/buildKeyframes'
import { MasterBannerContext } from '../../contexts/MasterBannerContext';
import libraryIn from '../../store/libraryIn.json';
import libraryOut from '../../store/libraryOut.json';
import './index.css';
import { AnimationButton, AnimationButton2, AnimationButton3 } from '../Icons';
import AllInclusiveIcon from '@mui/icons-material/AllInclusive';
import CustomKeyframe from './CustomKeyframe';
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import TurnedInNotIcon from '@mui/icons-material/TurnedInNot';
import TurnedInIcon from '@mui/icons-material/TurnedIn';
import SortIcon from '@mui/icons-material/Sort';
import Tooltip from '@mui/material/Tooltip';
import ElementAudio from './Audio';
import Properties from './Properties/index.js';
import Divider from '@mui/material/Divider';
import { Compliance } from './Compliance';
import { BannerRules } from './BannerRules';
import { resizedataURL } from '../../helpers/fileManager.js'
import { AuthValidatorContext } from '../../contexts/auth';

export default function Animation(params) {
  const { setLayerActive, layerActive, setReload, fullScreenRight} = useContext(SettingsBannerContext);
  const { master, setMaster } = useContext(MasterBannerContext);
  const [ , setIconLoop] = useState(layerActive[0].element.loop === -1)
  const [ , setAnimationActive ] = useState(null);
  const [ customkey, setCustomkey ] = useState(false);
  const refIframe = useRef(null);
  const refInputDuration = useRef(null);
  const refInputLoop = useRef(null);
  const refInputLoopIcon = useRef(null);
  const layer = params.layer;
  const { roles } = useContext(AuthValidatorContext);

  useEffect(()=>{
    checkLocalStorage()
  },[master.customKeyframe])
  
  const checkLocalStorage = async () => {
    const copyBanner = {...master};
    if(copyBanner.customKeyframe === undefined || copyBanner.customKeyframe.length === 0){
      const localStorageCustomKeyframes =  await localStorage.getItem('customKeyframes');
      if (localStorageCustomKeyframes && localStorageCustomKeyframes.length > 0) {
      const cookiesKeyframe = JSON.parse(localStorageCustomKeyframes);
      if (copyBanner.customKeyframe) {
        copyBanner.customKeyframe.forEach(custom => {
          custom.save = false;
        })
        cookiesKeyframe.forEach(cookie => {
          let insert = true;
          copyBanner.customKeyframe.forEach(custom => {
            if (custom.animation === cookie.animation) {
              custom.save = true;
              insert = false;
            }
          });
          if (insert) copyBanner.customKeyframe.push(cookie);
        });
      } else copyBanner.customKeyframe = cookiesKeyframe;
      if(copyBanner.customKeyframe.length !== 0){
        setMaster(copyBanner);
        setReload(true);
      }
    } else {
      return;
    }

  } else{
    return;
  }


  }
    
    var direction = "";
    var duration = "";
    var active = "";
    var keyframe = "";
    var html = "";
    var elementLoop = 0;
    
    master.elements.forEach(element => {
      for(let i = 0; i < layerActive.length; i++){
        if (element.id === layer[i].element.id) {
          if (layerActive[i].type === "in") {        
            active = element.animation.in.animation;
            direction = element.animation.in.direction;
          } else {
            active = element.animation.out.animation;
            direction = element.animation.out.direction;
          }
          duration = element.duration;
          elementLoop = element.loop;
        }
        if (element.id === layerActive[i].element.id) {
          var animationElement;
          if (layerActive[i].type === "in") {
            animationElement = element.animation.in;
          } else {
            animationElement = element.animation.out;        
          }
          duration = animationElement.duration;
          direction = animationElement.direction;
        }
      }
  });

  if (layer.length !== 0) {
    master.elements.forEach(element => {
        if (element.id === layer[0].element.id) {
          const a = layerActive[0].type.toLowerCase() === "in" ? element.animation.in : element.animation.out;
          if (a.customKeyframe) {
            master.customKeyframe.forEach(el => {
              if (el.animation === a.animation) {
                keyframe =  {style: el.keyframe, name: a.animation}
            }
          });
        } else {
          keyframe = BuildAnimationPreview(element, layerActive[0].type);
        }
      }
      

    });
    html = GetHTML(keyframe.style, keyframe.name);
    LoadIframe();
  }  

  function LoadIframe() {
    try {
      const iframe = refIframe.current.contentDocument;
      iframe.open();
      iframe.write(html);
      iframe.close();
    } catch(error) {}
  }


  function activeFilterType (el, arr) {
    for (let i = 0; i < arr.length; i++) {
      if (arr[i].type === el) {
        return true;
      }
    }
    return false;
  }
  
  const listAnimations = [];
  const arrayAnimation = layerActive[0].type.toLocaleLowerCase() === "in" ? libraryIn : libraryOut;
  if (master.customKeyframe) {
    master.customKeyframe.forEach(custom => {
      if (activeFilterType(custom.type, layerActive) === true)  listAnimations.push({name: custom.animation, custom: true, save: custom.save ? true : false});   
    });
  }

  arrayAnimation.forEach(item => {
    if (activeFilterType(item.type, layerActive) === true)  listAnimations.push({name: item.name, custom: false});
  });

  function ChangeAnimation(item) {
    setAnimationActive(item.name);
    // const html = GetHTML(keyframe.style, keyframe.name);
    const copyMaster = { ...master };
    const layerActiveArr = [];
    copyMaster.elements.forEach((element) => {
      for (let i = 0; i < layerActive.length; i++) {
        if (element.id === layer[i].element.id) {
          if (layerActive[i].type === "in") {
            element.animation.in.customKeyframe = item.custom;
            element.animation.in.animation = item.name;
          } else {
            element.animation.out.customKeyframe = item.custom;
            element.animation.out.animation = item.name;
          }
          layerActiveArr.push({
            element: element,
            type: layerActive[i].type
          });
        }
      }
    });
    setLayerActive(layerActiveArr);
    setMaster(copyMaster);
    LoadIframe();
    setReload(true);
  }

  const [ arrowDirection, setArrowDirection ] = useState('Left');

  function ChangeDirection(item) {
    var copyMaster = JSON.parse(JSON.stringify(master));
    copyMaster.elements.forEach(element => {
          for(let i = 0; i < layer.length; i++){
                if (element.id === layer[i].element.id) {
                    if (layerActive[i].type === "in") {
                        element.animation.in.direction = item;
                      } else {
                          element.animation.out.direction = item;
                        }
                      }
                    }
                    });
    setArrowDirection(item)
    setMaster(copyMaster);
    LoadIframe();
    setReload(true);
  }

  function ChangeDuration(evt) {
    try {
      if (evt.key === "Enter") {
        const value = parseFloat(evt.target.value.replace(',', '.').replace('s', '')).toFixed(1);
        if (value >= 0) {
          var copyMaster = JSON.parse(JSON.stringify(master));
          copyMaster.elements.forEach(element => {
            for(let i = 0; i < layer.length; i++ ){
              if (element.id === layer[i].element.id) {
                if (layerActive[i].type === "in") {
                  element.animation.in.duration = parseFloat(value).toFixed(1) * 1000;
                } else {
                  element.animation.out.duration = parseFloat(value).toFixed(1) * 1000;
                }
              }
            }
          });
          
          LoadIframe();
          setMaster(copyMaster);
          setReload(true);
        }
      }
    } catch (error) {}
  }
  
  function ChangeElementLoop(evt) {
    try {
      if (evt.key === "Enter") {
        const value = parseFloat(evt.target.value.replace(',', '.').replace('s', '')).toFixed(0);
        if (value >= 1) {
          var copyMaster = JSON.parse(JSON.stringify(master));
          copyMaster.elements.forEach(element => {
            for(let i = 0; i < layer.length; i++){

              if (element.id === layer[i].element.id) {
                element.loop = value;
              }
            }
          });
          refInputLoop.current.value = elementLoop === -1 ? "" : elementLoop;
          LoadIframe();
          setMaster(copyMaster);
          setReload(true);
        }
      }
    } catch (error) {}
  }
  function ChangeElementLoopInf() {
    try {
      var copyMaster = JSON.parse(JSON.stringify(master));
      var value = -1;
      copyMaster.elements.forEach(element => {
        for(let i = 0; i < layer.length; i++) {

          if (element.id === layer[i].element.id) {
            value = element.loop === -1 ? 1 : -1;
            element.loop = value;
            elementLoop = value;
          }
        }
      });
      setIconLoop(value === -1);
      LoadIframe();
      setMaster(copyMaster);
      setReload(true);
    } catch (error) {}
  }

  function OnHover(evt, item) {
    try {
      var div = evt.target.id.replaceAll("_id_a", "_id").replaceAll("_id_b", "_id").replaceAll("_id_c", "_id");
      var elementID = document.getElementById(div);
      elementID.style.right = "210px";
      elementID.style.opacity = "1";
      elementID.style.width = "40px";
      if (item.custom) {
        master.customKeyframe.forEach(el => {
          if (el.animation === item.name) {
            keyframe =  {style: el.keyframe, name: item.name}
          }
        });
      } else {
        keyframe = Keyframe({name: item.name, type: layerActive[0].type, direction: direction, duration:  duration});
      }
      html = GetHTML(keyframe.style, keyframe.name);;
      LoadIframe();    
    } catch {}
  }

  function OnLeave(evt) {
    try {
      var div = evt.target.id.replaceAll("_id_a", "_id").replaceAll("_id_b", "_id").replaceAll("_id_c", "_id");
      var elementID = document.getElementById(div);
      elementID.style.right = "0px";
      elementID.style.width = "0px";
      elementID.style.opacity = "0";
      keyframe = Keyframe({name: active, type: layerActive[0].type, direction: direction, duration:  duration});
      html = GetHTML(keyframe.style, keyframe.name);;
      LoadIframe();
    } catch {}
  }

  try {
    refInputDuration.current.value = `${(duration / 1000)}s`;
  } catch (error) { }

  try {
    refInputLoop.current.value = `${elementLoop === -1 ? "" : elementLoop}`;
  } catch (error) { }

  function CloseCustomKey() {
    setCustomkey(null);
  }

  function deleteCustomkey(layer) {
    var copyBanner = JSON.parse(JSON.stringify(master));
    const newCustomKeyframe = copyBanner.customKeyframe.filter(function( obj ) {
      obj.animation === layer.name ? obj.save = false : obj.save = true;
      return obj.animation !== layer.name;
    });
    const filteredCustomKeyframes = copyBanner.customKeyframe.filter((keyframe) => keyframe.save === true);
    localStorage.setItem('customKeyframes', JSON.stringify(filteredCustomKeyframes));
    copyBanner.customKeyframe = newCustomKeyframe;
    setMaster(copyBanner);
  }
  
  function localStorageSaveCustomkey(layer) {
    const copyBanner = {...master};
    copyBanner.customKeyframe.forEach((obj) => {
      if (obj.animation === layer.name) {
        obj.save = !obj.save;
      }
    });
    const filteredCustomKeyframes = copyBanner.customKeyframe.filter((keyframe) => keyframe.save === true);
    localStorage.setItem('customKeyframes', JSON.stringify(filteredCustomKeyframes));
    setMaster(copyBanner)
  }

  function editCustomkey(layer) {
    for (var i = 0; i < master.customKeyframe.length; i++) {
      if (master.customKeyframe[i].animation === layer.name) setCustomkey(master.customKeyframe[i])
    }
  }

  function previewCustomKeyframe(style, animationName) {
    html = GetHTML(style, animationName);
    LoadIframe();
  }

  function getCustomAnimation(layer) {
    for (var i = 0; i < master.elements.length; i++) {
      const element = master.elements[i];
      if (element.animation.in.animation === layer.name || element.animation.out.animation === layer.name) return true;
    }
    return false;
  }
  const custom = (layerActive[0].element.animation.in.customKeyframe && layerActive[0].type === "in") || (layerActive[0].element.animation.out.customKeyframe && layerActive[0].type === "out");

  function changeActiveType(type) {
    var newLayerActive = JSON.parse(JSON.stringify(layerActive));
    for(let i = 0; newLayerActive.length > i; i++){
      newLayerActive[i].type = type;
    }
    setLayerActive(newLayerActive);
  }
   function sortAlphabetOrder(listAnimations) {
    const masterCopy = {...master};
    if(master.customKeyframe.length > 0){
      const customKeyOrder = [...masterCopy.customKeyframe].sort((a, b) => {
        const AnimationA = a.animation.toUpperCase();
        const AnimationB = b.animation.toUpperCase();
        return (AnimationA > AnimationB) ? 1 : (AnimationA < AnimationB) ? -1 : 0;
      });
      masterCopy.customKeyframe = (JSON.stringify(customKeyOrder) === JSON.stringify(masterCopy.customKeyframe)) ? customKeyOrder.reverse() : customKeyOrder;
      setMaster(masterCopy);


      let arrayAnimationCopy = [...arrayAnimation]
      arrayAnimation.sort((a, b) => {
        const AnimationA = a.name.toUpperCase();
        const AnimationB = b.name.toUpperCase();
        return (AnimationA > AnimationB) ? 1 : (AnimationA < AnimationB) ? -1 : 0;
      });
    arrayAnimationCopy = (JSON.stringify(arrayAnimation) === JSON.stringify(arrayAnimationCopy)) ? arrayAnimation.reverse() : arrayAnimation;
    setReload(true)    
  } else{
      let arrayAnimationCopy = [...arrayAnimation]
      arrayAnimation.sort((a, b) => {
        const AnimationA = a.name.toUpperCase();
        const AnimationB = b.name.toUpperCase();
        return (AnimationA > AnimationB) ? 1 : (AnimationA < AnimationB) ? -1 : 0;
      });
      arrayAnimationCopy = (JSON.stringify(arrayAnimation) === JSON.stringify(arrayAnimationCopy)) ? arrayAnimation.reverse() : arrayAnimation;
      setReload(true)
    }    
    return 
  } 

  const [collapsedAnimationDiv, setCollapsedAnimationDiv] = useState(false);
  
  const handleCollapseAnimation = () => {
    setCollapsedAnimationDiv(!collapsedAnimationDiv)
  };

  const [divWidth, setDivWidth] = useState('310px')

  useEffect(() => {
    function handleResize() {
      if (!fullScreenRight) {
        const windowWidth = window.innerWidth;
        if (windowWidth >= 1900) {
          setDivWidth('310px');
        } else if (windowWidth >= 1600) {
          setDivWidth('290px');
        } else if (windowWidth >= 1300) {
          setDivWidth('270px');
        } else if (windowWidth >= 1200) {
          setDivWidth('260px');
        } else {
          setDivWidth('310px');
        }
      }
    }

    handleResize();
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [fullScreenRight]);

  async function handleChangeReduce(evt) {    
    try {
      var checked = evt.target.checked;
      var copyMaster = JSON.parse(JSON.stringify(master));
      for(let j = 0; j < copyMaster.elements.length; j++) {
        var element = copyMaster.elements[j];
        for(let i = 0; i < layer.length; i++) {
          if (element.id === layer[i].element.id) {
            element.reduce = checked;
            var originalBG = await resizedataURL(element.properties.originalBackground, element.properties.width * element.properties.scale / 100, element.properties.height * element.properties.scale / 100);
            element.properties.background = originalBG;
          }
        }
      }
      LoadIframe();
      setMaster(copyMaster);
      setReload(true);
    } catch (error) {}
  }

  return (
    <div className="animation-root" style={{
      width: fullScreenRight ? '0px' : divWidth,
      transition: 'width 500ms',
      overflowY: fullScreenRight ? 'hidden' : 'scroll'
      }}>
      <Properties/>
      {
        roles.compliance === 1 ?
        <Compliance/>
        :
        <></>
      }
      <BannerRules/>
      <ElementAudio/>
      <div className='animationTitleAndArrow'>
				<span style={{color: '#222222', fontWeight: 'bold', fontSize: '16px', margin: '15px 0 -5px 1px'}}>Animação</span>
				{collapsedAnimationDiv ? 
					<img src="assets/arrownew.png" className="stepNumberArrowUp" onClick={handleCollapseAnimation} style={{transform: "rotate(180deg)", padding: '5px', cursor: 'pointer', width: '11px', height: '7px', margin: '25px 0 0 0'}}/> :
					<img src="assets/arrownew.png" className="stepNumberArrowUp" onClick={handleCollapseAnimation} style={{padding: '5px', cursor: 'pointer', width: '11px', height: '7px', margin: '25px 0 0 0'}}/>
        }
			</div>
			<Divider className='animationDivider' />
      <div className="animation-preview" id="animation-preview" style={{display: collapsedAnimationDiv ? 'none' : 'flex'}}>
        <iframe className='previewContent' style={{border: 0, display: layerActive.length === 1 ? 'flex' : 'none'}} ref={refIframe} title="iframePreview"></iframe>
      </div>
      {
          customkey
        ?
        <CustomKeyframe custom={customkey} type={layerActive[0].type} onClick={() => CloseCustomKey()} preview={(style, animationName) => previewCustomKeyframe(style, animationName)}/> :
        <div>
        {
          !collapsedAnimationDiv ? <div className="animation-container-a" >
          <div className="animation-container-b">
            <div className="animation-container-tab" style={{zIndex: 1}} onClick={() => changeActiveType("in")}>
              <svg xmlns="http://www.w3.org/2000/svg" width="17.747" height="20.702" viewBox="0 0 17.747 20.702" style={{transform: 'scale(0.8)'}}>
                <g id="Grupo_376" dataname="Grupo 376" transform="translate(-1680.926 -331.149)">
                  <g id="Grupo_374" dataname="Grupo 374" transform="translate(-157 -69.293)">
                    <line id="Linha_13" dataname="Linha 13" y2="11.542" transform="translate(1838.926 410.225) rotate(-90)" fill="none" stroke={layerActive[0].type === "in" ? "#1B9ADA" : "#ABABAB"} strokeLinecap="round" strokeWidth="2"/>
                    <path id="Caminho_153" dataname="Caminho 153" d="M1812.22,4577.534l4.715,4.715,4.715-4.715" transform="translate(-2731.414 2227.161) rotate(-90)" fill="none" stroke={layerActive[0].type === "in" ? "#1B9ADA" : "#ABABAB"} strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"/>
                    <path id="Caminho_410" dataname="Caminho 410" d="M2340.688,407.1v-5.663h11.985v18.7h-11.985v-6.322" transform="translate(-498)" fill="none" stroke={layerActive[0].type === "in" ? "#1B9ADA" : "#ABABAB"} strokeLinejoin="round" strokeWidth="2"/>
                  </g>
                </g>
              </svg>
              <span style={{fontWeight: 'bold', fontSize: '14px', color: layerActive[0].type === "in" ? '#1B9ADA' : '#ABABAB', margin: '0px 0 0 5px'}}>Entrada</span>
            </div>
            <div className="animation-container-tab" style={{zIndex: 1}} onClick={() => changeActiveType("out")}>
              <svg xmlns="http://www.w3.org/2000/svg" width="21.747" height="20.702" viewBox="0 0 21.747 20.702" style={{transform: 'scale(0.8)'}}>
                <g id="Grupo_377" dataname="Grupo 377" transform="translate(-1755.926 -331.149)">
                  <g id="Grupo_375" dataname="Grupo 375" transform="translate(1756.926 332.149)">
                    <line id="Linha_13" dataname="Linha 13" y2="11.542" transform="translate(7.838 8.784) rotate(-90)" fill="none" stroke={layerActive[0].type === "out" ? "#DD1B58" : "#ABABAB"} strokeLinecap="round" strokeWidth="2"/>
                    <path id="Caminho_153" dataname="Caminho 153" d="M0,0,4.715,4.715,9.43,0" transform="translate(15.031 13.499) rotate(-90)" fill="none" stroke={layerActive[0].type === "out" ? "#DD1B58" : "#ABABAB"} strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"/>
                    <path id="Caminho_410" dataname="Caminho 410" d="M2352.673,407.1v-5.663h-11.985v18.7h11.985v-6.322" transform="translate(-2340.688 -401.441)" fill="none" stroke={layerActive[0].type === "out" ? "#DD1B58" : "#ABABAB"} strokeLinejoin="round" strokeWidth="2"/>
                  </g>
                </g>
              </svg>
              <span style={{fontWeight: 'bold', fontSize: '14px', color: layerActive[0].type === "in" ? '#ABABAB' : '#DD1B58', margin: '0px 0 0 5px'}}>Saída</span>
            </div>
            <div className="animation-container-tab" style={{background: layerActive[0].type === "in" ? '#FFFFFF' : '#F7F7F7', position: 'absolute', left: '0px', transition: 'left 500ms'}}></div>
            <div className="animation-container-tab" style={{background: layerActive[0].type === "out" ? '#FFFFFF' : '#F7F7F7', position: 'absolute', left: '136px', transition: 'left 500ms'}}></div>
          </div>
          <div className="animation-container-c">            
            <div className="animation-container-duration" style={{margin: '20px 0px 0px 20px', display: 'flex', width: '200px'}}>
              <input
                type="checkbox"
                onClick={(evt) => handleChangeReduce(evt)}
                style={{textAlign: 'center', fontSize: '14px', borderRadius: '4px'}}
                checked={layerActive[0].element.reduce}
                >
              </input>
              <span style={{textAlign: 'center'}}>Remover background-size</span>
            </div>
            {
              (layerActive[0].type === "in" && layerActive[0].element.animation.in.customKeyframe) || 
              (layerActive[0].type === "out" && layerActive[0].element.animation.out.customKeyframe) ?
              <></> :
              <>
                <div className="animation-container-direction" style={{padding: '10px 0 0 0'}}>
                  <span className="animation-text" style={{marginLeft: '20px'}}>Direção</span>
                  {
                    layerActive[0].type === "in" ? 
                    
                    <div className="animation-container-direction-buttons">
                    <div onClick={() => ChangeDirection("Top")} >
                      {arrowDirection === "Top" ? (<AnimationButton2 rotate="0" />) : (<AnimationButton rotate="0" />)}
                    </div>              
                    <div onClick={() => ChangeDirection("Bottom")} >
                      {arrowDirection === "Bottom" ? (<AnimationButton2 rotate="180" />) : (<AnimationButton rotate="180" />)}
                    </div>
                    <div onClick={() => ChangeDirection("Left")} >
                      {arrowDirection === "Left" ? (<AnimationButton2 rotate="270" />) : (<AnimationButton rotate="270" />)}
                    </div>
                    <div onClick={() => ChangeDirection("Right")} >
                      {arrowDirection === "Right" ? (<AnimationButton2 rotate="90" />) : (<AnimationButton rotate="90" />)}
                    </div>
                  </div> 
                  : 
                  <div className="animation-container-direction-buttons">
                    <div onClick={() => ChangeDirection("Top")} >
                      {arrowDirection === "Top" ? (<AnimationButton3 rotate="0" />) : (<AnimationButton rotate="0" />)}
                    </div>              
                    <div onClick={() => ChangeDirection("Bottom")} >
                      {arrowDirection === "Bottom" ? (<AnimationButton3 rotate="180" />) : (<AnimationButton rotate="180" />)}
                    </div>
                    <div onClick={() => ChangeDirection("Left")} >
                      {arrowDirection === "Left" ? (<AnimationButton3 rotate="270" />) : (<AnimationButton rotate="270" />)}
                    </div>
                    <div onClick={() => ChangeDirection("Right")} >
                      {arrowDirection === "Right" ? (<AnimationButton3 rotate="90" />) : (<AnimationButton rotate="90" />)}
                    </div>
                  </div>
                  }
                </div>


                <div className="animation-container-duration" style={{margin: '20px 0px 0px 20px', display: 'flex', width: '85%'}}>
                  <span style={{textAlign: 'center'}}>Duração da animação</span>
                  <input ref={refInputDuration}
                    onClick={() => refInputDuration.current.value = ""}
                    style={{width: '50px', height: '20px', textAlign: 'center', fontSize: '14px', borderRadius: '4px', border: layerActive[0].type === "in" ? '1px solid #1B9ADA' : '1px solid #DD1B58', margin: '6px 0 0 25px'}}
                    onKeyPress={(evt) => ChangeDuration(evt)} placeholder={(duration / 1000).toString() + "s"}>
                  </input>
                </div>
                <div className="animation-container-duration" style={{margin: '0px 0px 0px 20px', display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '85%'}}>
                  <span className="animation-text">Loop</span>
                  <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                    <AllInclusiveIcon
                        id="AllInclusiveIcon_active"
                        ref={refInputLoopIcon} 
                        onClick={() => ChangeElementLoopInf()} 
                        style={{cursor: 'pointer', margin: '0 0 0 0px', color: elementLoop === -1 ? '#DC1A59' : 'rgb(171, 171, 171)'}}/>
                    <input ref={refInputLoop}
                      disabled={elementLoop === -1}
                      onClick={() => refInputLoop.current.value = ""}
                      style={{width: '50px', height: '20px', textAlign: 'center', fontSize: '14px', borderRadius: '4px', border: layerActive[0].type === "in" ? '1px solid #1B9ADA' : '1px solid #DD1B58', margin: '0 0 0 20px'}}
                      onKeyPress={(evt) => ChangeElementLoop(evt)} placeholder={elementLoop === -1 ? "" : elementLoop}></input>
                  </div>
                </div>
              </>
            }
            <div className="animation-container-list" style={{margin: '10px 0 0 20px', height: layerActive[0].element.animation.in.customKeyframe ? '52vh' : '35vh', overflowX: 'hidden'}}>
            <div style={{display: 'flex',justifyContent: 'space-between'}}>
            <div>
            <span className="animation-text">Tipo de animação</span>
            </div>
            <div>
            <Tooltip  title="Ordenar">
              <SortIcon className="order-button transition" onClick={()=> sortAlphabetOrder()}> </SortIcon>
            </Tooltip>
            </div>
            </div>

              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  margin: 'auto',
                  alignItems: 'baseline',
                  width: '250px',
                  position: 'relative',
                  height: '50px'
                  }}
              >
                <div style={{display: 'flex', flexDirection: 'row', backgroundColor: 'transparent', width: '250px', margin: 'auto'}}>
                  <div style={{border: '1px solid red', width: active === layer ? '40px' : '0px', height: '10px', position: 'absolute', background: active === layer ? layerActive[0].type === "in" ? '#71CC6B' : '#EE6D6D' : '#ABABAB',
                  right: active === layer ? '210px' : '0px', bottom: '-2px', transition: 'right 500ms, opacity 500ms, width 500ms', opacity: active === layer ? 1 : 0, alignItems: 'center'}}>
                  </div>
                  <div style={{cursor: 'pointer', display: 'flex', alignItems: 'center', margin: '0 0 0 -8px'}}>
                  {
                    layerActive[0].type === "in" ?
                    <AddIcon style={{cursor: 'pointer', color: '#1B9ADA', transform: 'scale(0.7)'}} onClick={() => setCustomkey("new")}/>
                    :
                    <AddIcon style={{cursor: 'pointer', color: '#DD1B58', transform: 'scale(0.7)'}} onClick={() => setCustomkey("new")}/>
                  }
                    <span style={{fontWeight: 'normal', cursor: 'default', fontWeight: 'bold'}}> Animação Customizada </span>
                  </div>
                </div>
              </div>
              {
                listAnimations.map(layer => (
                <div
                  onMouseEnter={(evt) => active !== layer.name ? OnHover(evt, layer) : null}
                  onMouseLeave={(evt) => active !== layer.name ? OnLeave(evt) : null}
                  key={Math.random()}
                  id={`${layer.name}_animation_id_a`}
                  style={{display: 'flex', flexDirection: 'column', margin: '-10px 0 0 0', alignItems: 'baseline', width: '250px', position: 'relative', height: '50px'}}>
                    <div
                      id={`${layer.name}_animation_id_b`}
                      style={{
                        cursor: 'pointer',
                        display: 'flex',
                        flexDirection: 'row',
                        backgroundColor:
                          active === layer.name
                            ? layerActive[0].type === "in"
                            ? '#1B9ADA' : '#DD1B58'
                            : 'transparent',
                        width: '200px',
                        borderRadius: '4px',
                        padding: '0 0 0 10px',
                        margin: 'auto 0 auto 0px'
                        }}>
                      <div
                        id={`${layer.name}_animation_id`}
                        style={{
                          width: layerActive.length === 1 && active === layer.name ? '60px' : '0px',
                          borderRadius: '10px',
                          height: '3px', 
                          position: 'absolute',
                          background: active === layer.name ? layerActive[0].type === "in" ? '#FFFFFF' : '#EE6D6D' : '#ABABAB',
                          left: active === layer.name ? '10px' : '10px',
                          bottom: '12px', 
                          transition: 'right 500ms, opacity 500ms, width 500ms'
                          }}>
                      </div>
                      <div style={{cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent:'space-between', width: '100%', height: 'auto'}}>

                                <div style={{ display: 'flex', alignItems: 'baseline'}}>
                                <span
                                  onClick={() => ChangeAnimation(layer)}
                                  id={`${layer.name}_animation_id_c`} style={{fontWeight: 'normal', margin: 'auto', whiteSpace: 'nowrap', width: '130px', overflow: 'hidden', textOverflow: 'ellipsis',
                                  color: active === layer.name ? layerActive[0].type === "in" ? '#FFFFFF' : '#FFFFFF' : '#000000'}}
                                  >
                                    {layer.name}
                                </span>
                                </div>

                                <div style={{margin: 'auto', marginRight:'10px', display: layer.custom ? 'flex' : 'none'}}>
                                    <div style={{margin:'auto', display: layer.custom ? 'flex' : 'none'}}>
                                <Tooltip title="editar">
                                  <EditIcon className="customAnimationIcons" onClick={() => editCustomkey(layer)} style={{color: active === layer.name ? layerActive[0].type === "in" ? '#FFFFFF' : '#FFFFFF' : '#989898',}}/>
                                </Tooltip>
                                <Tooltip title="excluir">
                                  <DeleteIcon className='customAnimationIcons' style={{display: getCustomAnimation(layer) ? 'none' : 'flex', color: active === layer.name ? layerActive[0].type === "in" ? '#FFFFFF' : '#FFFFFF' : '#989898'}} onClick={() => deleteCustomkey(layer)}/>
                                </Tooltip>

                                </div>

                                <Tooltip title="salvar">
                                    <TurnedInNotIcon 
                                    className='animation'
                                    onClick={() => localStorageSaveCustomkey(layer)}
                                    style={{color: active === layer.name ? layerActive[0].type === "in" ? '#FFFFFF' : '#FFFFFF' : '#989898', display: layer.save === true ? 'none' : 'flex'}}
                                    />
                                </Tooltip>
                                    <TurnedInIcon
                                    className='animation'
                                    onClick={() => localStorageSaveCustomkey(layer)}
                                    style={{color: active === layer.name ? layerActive[0].type === "in" ? '#FFFFFF' : '#FFFFFF' : '#989898', display: layer.save === false ? 'none' : 'flex'}}/>
                                </div>


                            </div>
                          </div>
                        </div>
                ))}
            </div>
          </div>
        </div> : <div></div>
      }
    </div>
    } </div>
  )
}

export function GetHTML(keyframe, animation_name) {
  var html = `<html>
  <head>
    <meta charset="UTF-8">
    <meta name="apple-mobile-web-app-capable" content="yes">
    <meta name="viewport" content="minimum-scale=1,maximum-scale=1,width=device-width,user-scalable=no">
    <meta name="ad.size" content="width=240,height=160">
    <title>Preview</title>
    <style>
      body {
        margin: 0;
        padding: 0
      }

      #banner {
        -moz-box-sizing: border-box;
        -webkit-box-sizing: border-box;
        -webkit-user-select: none;
        -ms-user-select: none;
        user-select: none;
        box-sizing: border-box;
        overflow: hidden;
        position: relative;
        width: 240px;
        height: 160px;
        top: 0;
        left: 0;
        cursor: pointer
      }
  
      #banner:after {
        position: absolute;
        content: '';
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        z-index: 900
      }
  
      #banner:before {
        position: absolute;
        content: '';
        left: 0;
        top: 0;
        width: calc(100% - 2px);
        height: calc(100% - 2px);
        z-index: 901;
        border: 0
      }
  
      .logo {
        background: url(data:image/png;base64,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) no-repeat;
        width: 65;
        height: 65;
        left: 85;
        top: 40;
        opacity: 1;
        z-index: 1;
        position: absolute;
        transform-origin: 50% 50%;
      }
    </style>
    <style>
      #keyframe#
    </style>
  </head>
  <body>
      <div id="banner" class="banner">
        <div id="logo" class="logo"></div>
        <script type="text/javascript">
          var d = document;
          var el = function (e) {
            return d.querySelector(e)
          }
  
          function Point_Animation() {
            var e, t = 0,
              n = [],
              i = document.createElement("div");
  
            function o(e) {
              if (".all" == e) {
                t = 0;
                for (var i = 0; i < n.length; i++) {
                  for (var o = document.querySelectorAll("." + n[i][0]), r = 0; r < o.length; r++) o[r]
                    .classList.remove(n[i][1]);
                  clearTimeout(n[i][2])
                }
              } else
                for (var l = 0; l < n.length; l++)
                  if (n[l][0] == e.replace(".", "")) {
                    var a = document.querySelectorAll("." + n[l][0]);
                    for (r = 0; r < a.length; r++) a[r].classList.remove(n[l][1])
                  }
            }
            i.setAttribute("style",
                "margin:2px;width:95px;height:auto;background-color:#000000;color:white;z-index:9999;position:relative;text-align:center;top:0px;left:0px;opacity: 0.5;border-radius: 10px;font-size: 10px;line-height: 50px;"
              ), i.innerHTML = "<span>DEBUG:</span>", i.querySelector("span").setAttribute("style",
                "position: absolute;font-size: 9px;color: #fff;top: -16px;left: 31px;"), this
              .animationElements = function (r, l, a) {
                for (var s = 0, c = 0; c < l.length; c++) document.querySelector(l[c][0]) ? (t += 1e3 * l[c]
                  [1], e = l[c][0].replace(".", ""), window["timer" + c] = t, window["clear_" + e] =
                  setTimeout((function () {
                    if ("STOP_HERE" == r && a && a(), "LOOPING" == r) o(".all"), a && a();
                    else
                      for (var e = s; e == s; s++) {
                        window["elementMoment" + e] = l[e][0];
                        for (var t = document.querySelectorAll(window["elementMoment" +
                            e]), n = 0; n < t.length; n++) t[n].classList.add(r)
                      }
                  }), window["timer" + c]), n.push([e, r, window["clear_" + e]])) : (i.innerHTML = i
                  .innerHTML + l[c][0] + ": error<br>", document.body.appendChild(i))
              }, this.animationControlTime = function (e) {
                var t = 1,
                  n = document.createElement("div");
                n.setAttribute("style",
                    "width:95px;height:40px;background-color:#B50707;color:white;z-index:9999;position:relative;text-align:center;top:0px;left:0px;opacity: 0.5;border-radius: 50px;font-size: 22px;line-height: 50px;"
                  ), n.innerHTML = "<span>Timer animation:</span>", n.querySelector("span")
                  .setAttribute("style",
                    "position: absolute;font-size: 9px;color: #fff;top: -16px;left: 9px;"), document
                  .body.appendChild(n);
                var i = setInterval((function () {
                  var o, r = t.toString();
                  1 == r.length ? o = "0." + r.substr(0, 1) : 2 == r.length ? o = r.substr(0,
                      1) + "." + r.substr(1, 1) : 3 == r.length && (o = r.substr(0, 1) + r
                      .substr(1, 1) + "." + r.substr(2, 1)), n.innerHTML = o +
                    "<span>Timer animation:</span>s", n.querySelector("span").setAttribute(
                      "style",
                      "position: absolute;font-size: 9px;color: #fff;top: -16px;left: 9px;"
                    ), t++, el(e).addEventListener("transitionend", (function (e) {
                      clearInterval(i)
                    }), !1), el(e).addEventListener("webkitTransitionEnd", (function (e) {
                      clearInterval(i)
                    }), !1), el(e).addEventListener("oTransitionEnd", (function (e) {
                      clearInterval(i)
                    }), !1), el(e).addEventListener("animationend", (function (e) {
                      clearInterval(i)
                    }), !1), el(e).addEventListener("webkitAnimationEnd", (function (e) {
                      clearInterval(i)
                    }), !1), el(e).addEventListener("MSAnimationEnd", (function (e) {
                      clearInterval(i)
                    }), !1)
                }), 100)
              }, this.clearAnimation = o
          }
          var timeline = new Point_Animation();
  
          function animabanner() {
            count--;
            timeline.animationElements("#animation_name#", [
              [".logo", 0]
            ]);
            if (count > 0) {
              timeline.animationElements("LOOPING", [
                [".logo", 2]
              ], function () {
                animabanner()
              });
            }
          }
  
          var count = 9999;
  
          animabanner();
        </script>
      </div></body>
  
  </html>`;

  html = html.replace('#keyframe#', keyframe);
  html = html.replace('#animation_name#', animation_name);

  return html;
}
